import { IAsyncSubmitData, IAsyncSubmitResult } from '../types';

const DEFAULT_SUBMIT_DATA = {
  campaign_id: '',
  ad_infos: [],
  campaign_info: {},
  ad_channel: 1,
};

/** 格式化异步创建的提交数据 */
const _formatCreationSubmitData = data => Object.assign({}, DEFAULT_SUBMIT_DATA, data);

/**
 * 排除成功的adgroup部分，重新生成提交数据
 * 注意：这里的重试提交数据，不包含创意部分，创意有失败会回到创编流，不会直接在报错弹窗重试
 */
const getAllRetrySubmitData = ({
  submitCreationData,
  submitResult,
}: {
  submitCreationData: IAsyncSubmitData;
  submitResult: IAsyncSubmitResult;
}): IAsyncSubmitData => {
  const {
    ad_channel: adChannel,
    campaign_info: campaignInfo,
    ad_infos: adInfos,
    campaign_id: originCampaignId,
  } = submitCreationData;

  const { campaign_id: campaignId, ad_and_creative: adAndCreative, campaign_error_items: campaignErrorItems } =
    submitResult?.result || {};

  // campaign层级报错，则返回原本提交数据进行重试
  if (campaignErrorItems?.length > 0) {
    return _formatCreationSubmitData(submitCreationData);
  }

  const newAdInfos = [];
  adInfos.forEach((adInfo, adgroupIndex) => {
    const currentAdgroupSubmitResult = adAndCreative?.[adgroupIndex];
    const { ad_id: adId, all_creative_num, success_creative_num } = currentAdgroupSubmitResult || {};

    // 过滤掉已经成功创建的部分（有ad_id代表成功创建）
    if (!adId) {
      newAdInfos.push(adInfo);
    } else if (adId && all_creative_num !== success_creative_num) {
      newAdInfos.push(adInfo);
    }
  });

  // risk_info 在 service 层级，自动会补上
  return _formatCreationSubmitData({
    campaign_id: campaignId || originCampaignId || '',
    ad_infos: newAdInfos,
    campaign_info: campaignInfo,
    ad_channel: adChannel,
  });
};

/**
 * 获取指定下标的重试数据
 */
const getRetrySubmitDataByAdgroupIndex = ({ submitCreationData, submitResult, adgroupIndex }) => {
  const retrySubmitData = getAllRetrySubmitData({
    submitCreationData,
    submitResult,
  });
  const currentAdInfo = retrySubmitData.ad_infos[adgroupIndex];
  retrySubmitData.ad_infos = [currentAdInfo];

  return retrySubmitData;
};

/**
 * 获取重试数据
 * 目前仅支持 adgroup 层级数据的重试，创意层级报错，则可返回修改，不走重试
 */
export const getRetrySubmitData = ({ submitCreationData, submitResult, adgroupIndex }) => {
  if (adgroupIndex !== undefined) {
    return getRetrySubmitDataByAdgroupIndex({ submitCreationData, submitResult, adgroupIndex });
  }
  return getAllRetrySubmitData({ submitCreationData, submitResult });
};
